<template>
    <div>
        <Poptip transfer trigger="hover" placement="top" width="400">
            <template>
                <Button v-if="tabledata.length" type="dashed" size="small">{{tabledata[0].address}}</Button>
                <Button v-else-if="$ifauth('fun_edit_owner')" type="dashed" @click="addNewaddress(0)" size="small">{{$t('l.add_address')}}</Button>
            </template>
            <Table slot="content" :columns="columns" :data="tabledata"></Table>
        </Poptip>
        <Button @click="addNewaddress" v-if="tabledata.length && $ifauth('fun_edit_owner')" style="margin-left: 10px">{{$t('l.add_new_address')}}</Button>
    </div>
</template>

<script>
    import util from "../../libs/util";

    export default {
        name: "table-poptip",
        props: {
            data:{
                type:Object,
                required:true
            },
            communityId:{
                type:Number,
                required:true
            }
        },
        data() {
            return {
                columns: [
                    {
                        title: this.$t('l.address'),
                        key: "address",
                        align: "center",
                    },
                    {
                        title: this.$t('l.operation'),
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            if (!this.$ifauth('fun_edit_owner'))  {
                                return h('span', ['-'])
                            }
                            return h("ButtonGroup", [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.$emit('edit', params.row.index)
                                        }
                                    }
                                }, this.$t('l.edit')),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            let owner = params.row
                                            this.$emit('delete',owner)
                                        }
                                    }
                                }, this.$t('l.delete')),
                            ])
                        }
                    },
                ],
            }
        },
        methods:{
            addNewaddress(){
                this.$emit("addAddress")
            },
        },
        computed:{
            tabledata(){
                let newArr=[];
                if (this.data.j_address) {
                    this.data.j_address.forEach((item,index) => {
                        if (this.communityId==item.community.id){
                            newArr.push({id:this.data.id,index:index,address:item.building.name + (item.unit?item.unit.name:""),name:this.data.name,location:item,mobile:this.data.mobile});
                        }
                    });
                }
                return newArr;
            },
        },
    }
</script>

<style scoped>

</style>